// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2rKHZ","select":"Header_select__1MH2O","clinic":"Header_clinic__RBG_L"};